// extracted by mini-css-extract-plugin
export var actionButton = "_is-t";
export var buttonContainer = "_is-0";
export var buttonContainer2 = "_is-1";
export var buttonSection = "_is-2";
export var details = "_is-3";
export var dropdownItem = "_is-5";
export var dropdownItemsContainer = "_is-4";
export var fileInput = "_is-r";
export var headerButton = "_is-6";
export var icon = "_is-7";
export var input = "_is-8";
export var macroListItem = "_is-9";
export var mainContent = "_is-a";
export var microText = "_is-b";
export var modal = "_is-w";
export var optionsButton = "_is-c";
export var paperclip = "_is-s";
export var pillContent = "_is-d";
export var preview = "_is-e";
export var preview2 = "_is-f";
export var quillEditor = "_is-q";
export var selectedMacro = "_is-g";
export var sidebar = "_is-h";
export var sidebarHeader = "_is-j";
export var sidebarList = "_is-i";
export var sidebarListItem = "_is-k";
export var sidebarSearch = "_is-l";
export var snoozeDurationWrapper = "_is-v";
export var statusPillContainer = "_is-m";
export var tagsContainer = "_is-n";
export var unselectedMacro = "_is-o";
export var variable = "_is-u";
export var wrapper = "_is-p";